import request from '@/axios'

export function createCourseDetails (customer_id, payload) {
  return request({
    url: `V1/course/create/${customer_id}`,
    method: 'POST',
    data: payload
  })
}
export function updateCourseDetails (customer_id, payload, course_id) {
  return request({
    url: `V1/course/update/${customer_id}/${course_id}`,
    method: 'POST',
    data: payload
  })
}
export function getCourseDetails (customer_id, course_id) {
  return request({
    url: `V1/course/details/${customer_id}/${course_id}`,
    method: 'GET'
  })
}
export function updateCourseScheduleSetting (customer_id, course_id, payload) {
  return request({
    url: `V1/course/update/courseScheduleSetting/${customer_id}/${course_id}`,
    method: 'POST',
    data: payload
  })
}
export function getCourseScheduleSetting (customer_id, course_id) {
  return request({
    url: `V1/course/details/courseScheduleSetting/${customer_id}/${course_id}`,
    method: 'GET'
  })
}
export function updateCourseEnrollmentSetting (customer_id, course_id, payload) {
  return request({
    url: `V1/course/update/courseEnrollmentSetting/${customer_id}/${course_id}`,
    method: 'POST',
    data: payload
  })
}
export function getCourseEnrollmentSetting (customer_id, course_id) {
  return request({
    url: `V1/course/details/courseEnrollmentSetting/${customer_id}/${course_id}`,
    method: 'GET'
  })
}
export function updateCourseContentSetting (customer_id, course_id, payload) {
  return request({
    url: `V1/course/update/courseContentSetting/${customer_id}/${course_id}`,
    method: 'POST',
    data: payload
  })
}
export function getCourseContentSetting (customer_id, course_id) {
  return request({
    url: `V1/course/details/courseContentSetting/${customer_id}/${course_id}`,
    method: 'GET'
  })
}
export function getTopicList (customer_id, payload, page = 1) {
  return request({
    url: `V1/topic/list/${customer_id}?page=${page}`,
    method: 'POST',
    data: payload
  })
}
export function createTopic (customer_id, payload) {
  return request({
    url: `V1/topic/create/${customer_id}`,
    method: 'POST',
    data: payload
  })
}
export function updateTopic (customer_id, topic_id, payload) {
  return request({
    url: `V1/topic/update/${customer_id}/${topic_id}`,
    method: 'POST',
    data: payload
  })
}
export function updateCourseContent (customer_id, course_id, payload) {
  return request({
    url: `V1/course/update/courseContent/${customer_id}/${course_id}`,
    method: 'POST',
    data: payload
  })
}

export function deleteLessonsFromCourse (customer_id, course_id, payload) {
  return request({
    url:`/V1/course/delete/lessonFromCourse/${customer_id}/${course_id}`,
    method:'POST',
    data: payload
  })
}

export function getCourseContent (customer_id, course_id, payload) {
  return request({
    url: `V1/course/details/courseContent/${customer_id}/${course_id}`,
    method: 'GET',
    data: payload
  })
}

export function createLesson (customer_id, payload) {
  return request({
    url: `V1/lesson/create/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function cloneCourse (customer_id, course_id) {
  return request({
    url: `V1/course/clone/${customer_id}/${course_id}`,
    method: 'POST'
  })
}

export function addUsertoCourseApi (customer_id, course_id, payload) {
  return request({
    url: `V1/course/update/courseTutors/${customer_id}/${course_id}`,
    method: 'POST',
    data: payload
  })
}

export function newlessonListing (customer_id, payload, queryParams = 1, query) {
  return request({
    url:`V1/lesson/list/${customer_id}?attribute=${query.attribute}&direction=${query.direction}&field_type=${query.field_type}&page=${queryParams}`,
    method:'POST',
    data:payload
  })
}

export function newlessonfetch (customer_id, lesson_id) {
  return request({
    url:`V1/lesson/details/${customer_id}/${lesson_id}`,
    method:'GET'
  })
}
